import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-e-resource',
  templateUrl: './e-resource.component.html',
  styleUrls: ['./e-resource.component.scss']
})
export class EResourceComponent implements OnInit {

  selectedYear: string = '2023-24';
  
  pdfSources: { [key: string]: string } = {
    '2023-24': '/assets/pdf/academics/Lesson-Plan-Sample-2023-24.pdf',
    '2022-23': '/assets/pdf/academics/Lesson-Plan-Sample-2022-23.pdf',
    '2021-22': '/assets/pdf/academics/Lesson-Plan-Sample-2021-22.pdf'
  };

  constructor() { }

  ngOnInit(): void { }

  getPdfPath(): string {
    return this.pdfSources[this.selectedYear];
  }

}
